import React, { Component } from "react";

// import Typography from '@material-ui/core/Typography';

import UserListFunction from "./userListFunction";
import { withFirebase } from "../../Firebase";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import withAuthorization from "../../Session/withAuthorization";

import Navigation from "../../Navigation";

const UserListPage = () => {
  return (
    <>
      <Navigation content={<UserListForm />} />
    </>
  );
};

class UserListPageBase extends Component {
  render() {
    return (
      <>
        <UserListFunction props={this.props} />
        <label
          variant="caption"
          style={{
            display: "block",
            marginBottom: "auto",
            textAlign: "center",
            fontSize: "12px",
          }}
        >
          Copyright &copy; {new Date().getFullYear()} RAMPVER. All rights
          reserved.
        </label>
      </>
    );
  }
}

const condition = (authUser) => !!authUser;

const UserListForm = compose(
  withAuthorization(condition),
  withRouter,
  withFirebase
)(UserListPageBase);

export default UserListPage;

export { UserListForm };
